export default "__VITE_ASSET__D_P0edo3__"